import { Stack, Typography } from '@mui/material'

import { Card, Button } from '@repo/ui'

// Direct subpath import, not the `components` barrel: that barrel re-exports the
// onboarding folder, which reaches back into components/input/Search — a cycle.
import { TourRow, TOURS, openToursDialog, useProductTour } from 'components/onboarding'

/**
 * Getting started — the USER-scoped half of Home (VRG-340).
 *
 * Shown to EVERYONE, including the founder, and it is the whole of Home for someone who
 * cannot act on company setup. A Design hire joining a two-year-old brand has nothing to set
 * up and everything to learn; that is why this is a separate block from the checklist rather
 * than more rows in it.
 *
 * Renders the tour CATALOG, not `useOnPageUntakenTours` — that hook answers "what can I take
 * on the page I am looking at", and Home has no tour anchors, so it would always return [].
 *
 * KNOWN THIN: `TOURS` currently holds one tour against four declared categories. Authoring the
 * rest belongs to VRG-228 E6 and is deliberately held until the platform is complete, so this
 * block looks sparse by design. It is shipped now because the surface then exists to receive
 * tours as they are written, rather than needing a second pass — and one tour plus a route
 * into the Help hub still beats landing on an empty table.
 */
export const GettingStartedTours = () => {
  const { startTour, tourProgress, isTourProgressReady } = useProductTour()

  return (
    <Card spacing={4}>
      <Stack direction="row" alignItems="baseline" justifyContent="space-between">
        <Typography variant="h6">Getting started</Typography>
        <Button variant="text" onClick={openToursDialog}>
          Browse all tours
        </Button>
      </Stack>

      <Typography variant="body3" color="text.secondary" sx={{ lineHeight: 1.5 }}>
        Short guided walkthroughs of the product. You can replay any of them later from Help.
      </Typography>

      <Stack spacing={2}>
        {TOURS.map((tour) => (
          <TourRow
            key={tour.id}
            tour={tour}
            onClick={() => startTour(tour.id)}
            // Withheld until progress has actually loaded. `tourProgress` returns undefined
            // both for "untaken" and for "not known yet", so rendering it early shows a tour
            // someone finished months ago as though they had never opened it.
            progress={isTourProgressReady ? tourProgress(tour.id) : undefined}
          />
        ))}
      </Stack>
    </Card>
  )
}
